import * as React from 'react';
import { observer, inject } from 'mobx-react';
import { withTheme } from 'styled-components';
import Tabs from './Tabs';
import Tab from './Tab';
import { DataStore } from '../stores';

interface FundTypeTabsProps {
    theme?: { [property: string]: string | number };
    dataStore?: DataStore;
}

const FundTypeTabs: React.SFC<FundTypeTabsProps> = ({ theme, dataStore }) => (
    <Tabs {...theme.FundTypeTabs}>
        {dataStore.config.fundTypes.map((fundType, index) => (
            <Tab
                key={fundType.fundType}
                onClick={() => dataStore.config.setFundType(fundType)}
                isSelected={
                    fundType.fundType ===
                    dataStore.config.selectedFundType.fundType
                }
                {...theme.FundTypeTab}
            >
                {fundType.label}
            </Tab>
        ))}
    </Tabs>
);

export default inject('dataStore')(observer(withTheme(FundTypeTabs)));



// WEBPACK FOOTER //
// ./src/Components/FundTypeTabs.tsx